export default function ExecutionControl() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Контроль исполнения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как контролировать выполнение задач без микроменеджмента
        </p>

        <div className="grid sm:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto">
          <div className="bg-green-50 rounded-xl border border-green-200 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-green-200 flex items-center justify-center">
                <i className="ri-check-double-line text-green-700"></i>
              </div>
              <h3 className="font-bold text-green-800 text-base">Контроль результата</h3>
            </div>
            <p className="text-green-700 text-sm leading-relaxed">
              Руководитель проверяет итоговый результат в заранее согласованные моменты. Между контрольными точками сотрудник работает самостоятельно. Такой подход развивает ответственность и самостоятельность.
            </p>
          </div>
          <div className="bg-red-50 rounded-xl border border-red-200 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-red-200 flex items-center justify-center">
                <i className="ri-eye-close-line text-red-700"></i>
              </div>
              <h3 className="font-bold text-red-800 text-base">Контроль каждого действия</h3>
            </div>
            <p className="text-red-700 text-sm leading-relaxed">
              Руководитель постоянно следит за процессом и вмешивается в каждое действие сотрудника. Это демотивирует, тормозит работу и лишает сотрудника возможности развивать самостоятельность.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[
            { title: 'Контрольные точки', desc: 'Заранее согласованные моменты проверки. Не «зайду посмотреть, как дела», а «в четверг в 15:00 смотрим черновик отчёта».' },
            { title: 'Промежуточные результаты', desc: 'Для длительных задач важно видеть не только финальный результат, но и промежуточные этапы — это снижает риск сюрпризов в дедлайн.' },
            { title: 'Отчётность', desc: 'Формат и периодичность отчётности должны быть определены заранее. Например: короткий письменный статус раз в неделю или устный отчёт на планёрке.' },
            { title: 'Критерии качества', desc: 'Сотрудник должен знать, по каким критериям будет оцениваться результат. Это делает контроль объективным, а не субъективным.' },
            { title: 'Формат коммуникации', desc: 'Как и когда сотрудник сообщает о проблемах. Важно: сотрудник должен иметь возможность сообщить о трудностях, не дожидаясь контрольной точки.' },
            { title: 'Действия при отклонении', desc: 'Что делать, если на контрольной точке видно отклонение от плана: корректируем задачу, помогаем ресурсами, меняем срок — но не забираем задачу обратно.' },
          ].map((item) => (
            <div key={item.title} className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}